import { AccountingConfiguration, EApPlatform } from '@notch-ordering/shared-logic';

export function getAccountingConfigurationType(accountingConfig: AccountingConfiguration | null | undefined): EApPlatform {
    return (accountingConfig?.data?.platform ?? accountingConfig?.type) as EApPlatform;
}
